import React, { Component } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import { Columns, Column, Button, ButtonGroup } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'
import BarChart from './BarChart'
import PieChart from './PieChart'
import styles from './statisticsDistributed.style'
import { sendChangeChartEvent } from '../../../util/ga-helpers'

class StatisticsDistributed extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: 'bar',
    }
  }

  setChartType(type) {
    this.setState(
      state =>
        update(state, {
          type: { $set: type },
        }),
      () => this.buildChart(),
    )
  }

  buildChart() {
    if (this.state.type === 'pie') {
      return (
        <PieChart
          data={this.props.data.pie}
          labels={this.props.labels}
          dllink={getText('statistics.dllink')}
          unit={this.props.unit}
        />
      )
    }
    return (
      <BarChart
        data={this.props.data.bar}
        dllink={getText('statistics.dllink')}
        period={this.props.periodType}
        unit={this.props.unit}
      />
    )
  }

  render() {
    return (
      <Columns>
        <Column col12>
          <div style={styles.board}>
            <div>
              <div>
                <Columns>
                  <Column col6>
                    <h3 style={styles.title}>{this.props.title}</h3>
                    <span style={styles.period}>
                      <strong>{getText('statistics.timespan')}:</strong>{' '}
                      {this.props.period}
                    </span>
                  </Column>
                  <Column col2 />
                  <Column col4>
                    <ButtonGroup spacing>
                      <Button
                        text={getText('statistics.bar')}
                        type={this.state.type === 'bar' ? 'primary' : 'normal'}
                        onClick={() => {
                          this.setChartType('bar')
                          sendChangeChartEvent('Bar chart')
                        }}
                      />
                      <Button
                        text={getText('statistics.pie')}
                        type={this.state.type === 'pie' ? 'primary' : 'normal'}
                        onClick={() => {
                          this.setChartType('pie')
                          sendChangeChartEvent('Pie chart')
                        }}
                      />
                    </ButtonGroup>
                  </Column>
                </Columns>
              </div>
              {this.props.data.bar.length ? this.buildChart() : null}
            </div>
          </div>
        </Column>
      </Columns>
    )
  }
}

StatisticsDistributed.propTypes = {
  data: PropTypes.object.isRequired,
  periodType: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  labels: PropTypes.array.isRequired,
  unit: PropTypes.string,
}

StatisticsDistributed.defaultProps = {
  unit: '',
}

export default StatisticsDistributed
